import ContextMenuEntry from '~/components/ContextMenuEntry';
import ArchiveIcon from '~/icons/ArchiveIcon';
import DownloadIcon from '~/icons/DownloadIcon';
import EditIcon from '~/icons/EditIcon';
import TrashIcon from '~/icons/TrashIcon';
import { openInNewTab } from '~/utils/utils';
import { useEstimateListContext } from '../hooks/useEstimateListContext';
import InvoiceIcon from '~/icons/InvoiceIcon';

interface IEstimateContextMenuProps {
  estimateReferenceId: string;
}

const EstimateContextMenu = ({ estimateReferenceId }: IEstimateContextMenuProps) => {
  const {
    listData,
    onOpenDeleteEstimateModal,
    onEditEstimate,
    onEditListEstimate,
    convertEstimateToInvoice,
  } = useEstimateListContext();
  const thisEstimateData = listData[estimateReferenceId];

  return (
    <ContextMenuEntry
      sections={[
        {
          key: 'estimate',
          options: [
            {
              text: 'Edit Estimate',
              onClick: () => {
                onEditEstimate(estimateReferenceId);
              },
              isEnabled:
                thisEstimateData.payment_status !== 'Paid' && thisEstimateData.archived === false,
              icon: <EditIcon />,
            },
            // {
            //   text: 'Mark as Sent',
            //   isVisible: thisEstimateData.status === 'Draft' && thisEstimateData.archived === false,
            //   onClick: () => {
            //     onEditListEstimate(estimateReferenceId, { status: 'Sent' });
            //   },
            //   icon: <CheckIcon />,
            // },
            // {
            //   text: 'Mark as Paid',
            //   isVisible:
            //     thisEstimateData.status === 'Sent' && thisEstimateData.payment_status !== 'Paid',
            //   onClick: () => {
            //     onEditListEstimate(estimateReferenceId, { payment_status: 'Paid' });
            //   },
            //   icon: <CheckIcon />,
            // },
            // {
            //   text: 'Copy Estimate Link',
            //   onClick: () => {
            //     copyToClipboard(publicLink, 'Estimate link copied to clipboard');
            //   },
            //   icon: <LinkIcon />,
            //   isVisible: thisEstimateData.archived === false,
            // },
            {
              text: 'Convert to Invoice',
              onClick: () => {
                convertEstimateToInvoice(estimateReferenceId);
              },
              isEnabled: thisEstimateData.archived === false,
              icon: <InvoiceIcon fill="var(--neut1)" size={18} />,
            },
            {
              text: 'Download as PDF',
              onClick: () => {
                openInNewTab(thisEstimateData.pdf_url);
              },
              icon: <DownloadIcon />,
            },
          ],
        },

        {
          key: 'danger-estimate',
          options: [
            {
              text: 'Archive',
              onClick: () => {
                onEditListEstimate(estimateReferenceId, { archived: false });
              },
              color: 'danger',
              icon: <ArchiveIcon />,
              isVisible: thisEstimateData.archived === false,
            },
            {
              text: 'Delete',
              onClick: () => {
                onOpenDeleteEstimateModal(estimateReferenceId);
              },
              color: 'danger',
              icon: <TrashIcon />,
            },
          ],
        },
      ]}
    />
  );
};

export default EstimateContextMenu;
